// extracted by mini-css-extract-plugin
export default {"projectWrapper":"MainProjects_projectWrapper__J5lgH","MainProjects":"MainProjects_MainProjects__0wg0E"};